/* Autogenerated file. Do not edit manually. */
/* eslint-disable */
import { Contract, Interface } from "ethers";
const _abi = [
    {
        type: "constructor",
        inputs: [
            {
                name: "_topupRouterAddr",
                type: "address",
                internalType: "address",
            },
            {
                name: "_h2SwapAddr",
                type: "address",
                internalType: "address",
            },
        ],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "h2SwapAddr",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "address",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "owner",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "address",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "renounceOwnership",
        inputs: [],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "swapAndDeposit",
        inputs: [
            {
                name: "_inToken",
                type: "address",
                internalType: "address",
            },
            {
                name: "_fundOwner",
                type: "address",
                internalType: "address",
            },
            {
                name: "_amount",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "_outToken",
                type: "address",
                internalType: "address",
            },
            {
                name: "_swapTokens",
                type: "address[]",
                internalType: "address[]",
            },
            {
                name: "_swapData",
                type: "bytes[]",
                internalType: "bytes[]",
            },
        ],
        outputs: [],
        stateMutability: "payable",
    },
    {
        type: "function",
        name: "topupRouterAddr",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "address",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "transferOwnership",
        inputs: [
            {
                name: "newOwner",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "updateH2SwapAddr",
        inputs: [
            {
                name: "_addr",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "updateTopupRouterAddr",
        inputs: [
            {
                name: "_addr",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "event",
        name: "OwnershipTransferred",
        inputs: [
            {
                name: "previousOwner",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "newOwner",
                type: "address",
                indexed: true,
                internalType: "address",
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "TopupRouterDeposited",
        inputs: [
            {
                name: "fundOwner",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "inToken",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "inAmount",
                type: "uint256",
                indexed: false,
                internalType: "uint256",
            },
            {
                name: "outToken",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "outAmount",
                type: "uint256",
                indexed: false,
                internalType: "uint256",
            },
        ],
        anonymous: false,
    },
    {
        type: "error",
        name: "OwnableInvalidOwner",
        inputs: [
            {
                name: "owner",
                type: "address",
                internalType: "address",
            },
        ],
    },
    {
        type: "error",
        name: "OwnableUnauthorizedAccount",
        inputs: [
            {
                name: "account",
                type: "address",
                internalType: "address",
            },
        ],
    },
    {
        type: "error",
        name: "ReentrancyGuardReentrantCall",
        inputs: [],
    },
];
export class TopupWithH2Router__factory {
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
TopupWithH2Router__factory.abi = _abi;
